const normalizeLabel = (value) => (value ?? '').trim().replace(/\s+/g, ' ').toLowerCase();

export const validateFanPoll = (draft) => {
    const errors = {};
    if (!draft?.label?.trim()) errors.label = 'Admin/display title is required.';
    if (!draft?.question?.trim()) errors.question = 'Poll question is required.';
    if (!draft?.pollType) errors.pollType = 'Poll type is required.';
    if (!draft?.mainTag) errors.mainTag = 'A primary artist or genre is required.';
    if (!draft?.subject?.trim()) errors.subject = 'Poll subject is required.';
    if (!draft?.imageMetadata) errors.imageMetadata = 'Poll photo is required.';

    const options = draft?.options ?? [];
    if (options.length < 2 || options.length > 8) {
        errors.options = 'A poll must have between 2 and 8 options.';
    } else {
        const normalized = options.map(option => normalizeLabel(option.label));
        if (normalized.some(label => !label)) {
            errors.options = 'Every option must have a label.';
        } else if (new Set(normalized).size !== normalized.length) {
            errors.options = 'Option labels must be unique.';
        }
        const ids = options.map(option => option.id).filter(Boolean);
        if (new Set(ids).size !== ids.length) errors.options = 'Option IDs must be unique.';
    }

    if (draft?.startDate && draft?.endDate
        && Date.parse(draft.endDate) <= Date.parse(draft.startDate)) {
        errors.endDate = 'End date must be later than start date.';
    }
    return errors;
};

export const validationMessages = (errors) => [...new Set(Object.values(errors ?? {}))];

export const hasValidationErrors = (errors) => Object.keys(errors ?? {}).length > 0;
